export const width_oms = {
    width_i: 40,
}

export const symbol_status_oms_eng = [
    // {
    //     title: `Bifidobacterium bifidum`,
    //     Xpos_img: 288,
    //     Ypos_img: 245,
    //     page: 18,
    //     status_mapping: [
    //         { result:'Deficient', img: 'wrong_new' },
    //         { result:'Slightly Deficient', img: 'wrong_new' },
    //         { result:'Normal', img: 'correct_new' },
    //     ]
    // },
    // {
    //     title: `Lactobacillus gasseri`,
    //     Xpos_img: 288,
    //     Ypos_img: 302,
    //     page: 18,
    //     status_mapping: [
    //         { result:'Deficient', img: 'wrong_new' },
    //         { result:'Slightly Deficient', img: 'wrong_new' },
    //         { result:'Normal', img: 'correct_new' },
    //     ]
    // },
    // {
    //     title: `Lactobacillus paracasei`,
    //     Xpos_img: 288,
    //     Ypos_img: 356,
    //     page: 18,
    //     status_mapping: [
    //         { result:'Deficient', img: 'wrong_new' },
    //         { result:'Slightly Deficient', img: 'wrong_new' },
    //         { result:'Normal', img: 'correct_new' },
    //     ]
    // },
    // {
    //     title: `Lactobacillus rhamnosus`,
    //     Xpos_img: 288,
    //     Ypos_img: 410,
    //     page: 18,
    //     status_mapping: [
    //         { result:'Deficient', img: 'wrong_new' },
    //         { result:'Slightly Deficient', img: 'wrong_new' },
    //         { result:'Normal', img: 'correct_new' },
    //     ]
    // },
    // {
    //     title: `Lactobacillus reuteri`,
    //     Xpos_img: 288,
    //     Ypos_img: 465,
    //     page: 18,
    //     status_mapping: [
    //         { result:'Deficient', img: 'wrong_new' },
    //         { result:'Slightly Deficient', img: 'wrong_new' },
    //         { result:'Normal', img: 'correct_new' },
    //     ]
    // }
]

export const symbol_status_oms_thai = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 400,
        Ypos_img: 340,
        page: 20,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus gasseri`,
        Xpos_img: 400,
        Ypos_img: 422,
        page: 20,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus paracasei`,
        Xpos_img: 400,
        Ypos_img: 500,
        page: 20,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 400,
        Ypos_img: 580,
        page: 20,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 400,
        Ypos_img: 660,
        page: 20,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]

// Export the combined object that the component expects
export const symbol_status_oms = {
    eng: symbol_status_oms_eng,
    thai: symbol_status_oms_thai
}